<template>
<!--服务-->
  <div class="skill TopHeadder">
       <div class="bannerBox">
          <img src="../assets/image/fw_banner.png" />
           <div class="bannerTitle">
             <h3>坚守以客户为中心</h3>
             <p>为客户提供高效服务保障</p>
             <p>坚持使命必达</p>
          </div>
      </div>
       <div class="data_item1 PublicPadding">
         <h4 class="title">贯穿客户生命周期的客户成功体系</h4>
         <ul>
            <li class="datali1">
                <i><img src="../assets/image/pr1_1.png" /></i>
                <h3>产品专业</h3>
                <p>拒绝自嗨式推销提供匹配需求的产品</p>
            </li>
            <li class="datali2">
                <i><img src="../assets/image/pr1_2.png" /></i>
                <h3>服务专属</h3>
                <p>4V1专属团队管家式的全程支撑</p>
            </li>
            <li class="datali3">
                <i><img src="../assets/image/pr1_3.png" /></i>
                <h3>客户成功</h3>
                <p>客户成功导向，您成功才是我们成功</p>
            </li>
            <li class="datali4">
                <i><img src="../assets/image/pr1_4.png" /></i>
                <h3>共同成长</h3>
                <p>拓展业务知识，一起遇见更好的自己</p>
            </li>

         </ul>
      </div>
      <div class="fw_item2 PublicPadding colorbg">
         <h4 class="title">对于安全，我们从不马虎</h4>
         <h5 class="titleh5">银行级数据安全体系，保障企业信息安全</h5>
         <ul>
            <li>
                <h3>物理安全</h3>
                <i><img src="../assets/image/fw2_1.png" /></i>
                <p>电信5星级的机房具有充分的备灾措施，能够提供持续的安全服务。</p>
            </li>
            <li>
                <h3>系统安全</h3>
                <i><img src="../assets/image/fw2_2.png" /></i>
                <p>阿里云多年信息安全风险管控来保证服务与安全，并与顶尖机构共同全面检测系统漏洞。</p>
            </li>
            <li>
                <h3>应用安全</h3>
                <i><img src="../assets/image/fw2_3.png" /></i>
                <p>数据使用流程的制度建立确保数据独立性与安全性，同时对重要数据进行加密存储并统一管理。</p>
            </li>
            <li>
                <h3>网络安全</h3>
                <i><img src="../assets/image/fw2_4.png" /></i>
                <p>顶尖安全机构专业评估监测安全，通过传输层基于SSL/TLS协议，保障网络传输安全</p>
            </li>

         </ul>
      </div>
      <div class="p_item4 PublicPadding">
       <h4 class="title">随时随地，卓越服务在身边</h4>
       <ul>
            <li class="hot4_li1">
                <p>上线阶段专业团队、灰度测试，把问题留在上线前</p>
            </li>
            <li class="hot4_li2">
                <p>计划阶段深度剖析客户业务需求，组建专属项目交付团队，制定完善的项目实施计划</p>
            </li>
            <li class="hot4_li3">
                <p>验收阶段通过项目试运行，实现各节点的高效优质运营，以效果作为验收的标准</p>
            </li>
            <li class="hot4_li4">
                <p>实施阶段严格的节点管理制度，以结果为导向的交付模式，以优质的过程管理确保高效实施</p>
            </li>
            <li class="hot4_li5">
                <p>售后阶段验收只是合作的开始。持续跟进项目运营，为卓越客户体验提供持续护航</p>
            </li>
       </ul>
     </div>
      <Popup v-show="$store.state.isshow"></Popup>
  </div>
</template>

<script>
import Popup from "@/components/popup"
export default {
  name: 'product',
  data () {
    return {
      
    }
  },
 components:{
      Popup
  },
   methods:{
   
    popup(){
       this.$store.commit("openPop",{isopen:true,type:1})
    },
  
  }
}
</script>


<style scoped>
.bannerTitle{
    left:0.2rem;
}
.bannerTitle h3{
    font-size:0.36rem;
}
.bannerTitle p{
    text-align:left;
}
.data_item1 .titleh5{
    width: 6.1rem;
    margin: 0 auto;
    color: #999999;
    margin-top:0.3rem;
}
.data_item1 ul{
    overflow: hidden;
    box-shadow: 0 0 0.08rem #ccc;
    width: 7rem;
    margin:0 auto;
    margin-top:0.5rem;
}
.data_item1 ul li{
    width: 3.49rem;
    height: 3.6rem;
    float: left;
}
.data_item1 ul li i{
    display: block;
    width: 1.28rem;
    height:1.28rem;
    margin: 0 auto;
    margin-top:0.37rem;  
}
.data_item1 ul li i img{
    display: block;
    width: 1.28rem;
    height: 1.28rem;   
}
.data_item1 ul li h3{
    font-size: 0.24rem;
    font-weight: 400;
    color: #333333;
    margin-top:0.2rem;
    margin-bottom:0.2rem ;
    text-align: center;
}
.data_item1 ul li p{
    width: 2.2rem;
    font-size: 0.2rem;
    color: #999999;
    line-height: 0.36rem;
    margin: 0 auto;
    text-align: center;
}
.data_item1 ul li.datali1{
    border-right: 0.01rem solid #ccc;
    border-bottom: 0.01rem solid #ccc;
}
.data_item1 ul li.datali2{
     width: 3.49rem;
     height: 3.6rem;
     border-bottom:0.01rem solid #ccc;
}
.data_item1 ul li.datali3{
     width: 3.49rem;
     height: 3.61rem;
}
.data_item1 ul li.datali4{
     border-left: 0.01rem solid #ccc;
}
.titleh5{
   margin-top:0.2rem;
}
.fw_item2 ul{
    margin-top:0.3rem;
    overflow: hidden;
    margin-left:0.05rem;
}
.fw_item2 ul li {
    float: left;
    width:3.4rem;
    margin-left: 0.2rem;
    background: #fff;
    height:4.4rem;
    margin-top:0.3rem;
}
.fw_item2 ul li h3 {
    font-size: 0.2rem;
    font-weight: 400;
    color: #333333;
    line-height: 0.85rem;
    text-align: center;
    background: #e1ebf0;
}
.fw_item2 ul li i{
    display:block;
    width:1.03rem;
    height:0.98rem;
    margin:0 auto;
    margin-top:0.4rem;
    margin-bottom:0.24rem;
}
.fw_item2 ul li i img{
     display:block;
    width:1.03rem;
    height:0.98rem;
}
.fw_item2 ul li p {
    font-size: 0.14rem;
    color: #999999;
    line-height: 0.32rem;
    width:2.6rem;
    margin:0 auto;
}
.p_item4 ul{
    width: 2.45rem;
    height: 6.85rem;
    margin:0 auto;
    background:url("../assets/image/fw3_bg.png") no-repeat center;
    background-size:100% 100%;
    position: relative;  
    margin-top: 0.65rem;
    margin-bottom: 0.65rem;
}
.p_item4 ul li{
    width: 3.78rem;
    height: 1.54rem;
}
.p_item4 ul .hot4_li1{
    position: absolute; 
    right: -2.5rem;
    top: -0.1rem;
    background:url("../assets/image/fw3_right.png") no-repeat center;
    background-size:100% 100%;
}
.p_item4 ul .hot4_li2{
    position: absolute;
    left: -2.5rem;
    top: 1.5rem;
    background:url("../assets/image/fw3_left.png") no-repeat center;
    background-size:100% 100%;
}
.p_item4 ul .hot4_li3{
    position: absolute;
    right: -2.5rem;
    top: 2.8rem;
    background:url("../assets/image/fw3_right.png") no-repeat center;
    background-size:100% 100%;
}
.p_item4 ul .hot4_li4{
    position: absolute;
    left: -2.5rem;
    bottom: 1.2rem;
    background:url("../assets/image/fw3_left.png") no-repeat center;
    background-size:100% 100%;
}
.p_item4 ul .hot4_li5{
    position: absolute;
    right: -2.5rem;
    bottom: -0.2rem;
    background:url("../assets/image/fw3_right.png") no-repeat center;
    background-size:100% 100%;
}

.p_item4 ul li p{
    width:2.8rem;
    margin: 0 auto;
    font-size: 0.18rem;
    color: #999999;
    margin-top:0.2rem;
}
.p_item4 ul li.hot4_li3 h3{
    margin-top:0.8rem;
}
.p_item4 ul li.hot4_li4 h3{
    margin-top:0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/product.vue